const prevSlide = document.querySelector(".c-brands-slider-nav__prev");
const nextSlide = document.querySelector(".c-brands-slider-nav__next");
const carousel = document.querySelector(".c-brands-slider");
const carouselContainer = document.querySelector(".c-brands-slider-container");
const track = document.querySelector(".c-brands-slider-list");

if(typeof(carousel) != 'undefined' && carousel != null){
    let width = carousel.offsetWidth;
    let sliderIndex = 0;

    window.addEventListener("resize", function () {
        width = carouselContainer.offsetWidth;
    });

    nextSlide.addEventListener("click", function (e) {
        e.preventDefault();
        sliderIndex = sliderIndex + 1;

        prevSlide.classList.add("show");
        track.style.transform = "translateX(" + sliderIndex * -width + "px)";
        let tracklength = track.querySelectorAll('.c-brands-slider-list__item').length;
        let screenwidth = screen.width;
        let showlength = 0;
        if(screenwidth >=1200){
            showlength = 6;
        } else {
            showlength = 4;
        }

        console.log(tracklength);
        console.log(showlength);
        console.log(sliderIndex);
        if (tracklength / showlength  < sliderIndex +1) {
            nextSlide.classList.add("hide");
        }
    });
    prevSlide.addEventListener("click", function () {
        sliderIndex = sliderIndex - 1;
        if (sliderIndex < 0){
            sliderIndex = 0;
        }

        nextSlide.classList.remove("hide");
        if (sliderIndex === 0) {
            prevSlide.classList.remove("show");
        }
        track.style.transform = "translateX(" + sliderIndex * -width + "px)";
    });
}

